import * as React from 'react'

import { Box, Button, List, Section, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import attendancePolicies from 'modules/attendance/store/collections/policies'
import attendanceSettings from 'modules/attendance/store/collections/settings'
import type AttendancePolicy from 'modules/attendance/store/models/AttendancePolicy'

import PolicyCard from './PolicyCard'

const TimeTrackingPolicy = () => {
  const { loading } = useAsyncData(
    () => Promise.all([attendancePolicies.fetch(), attendanceSettings.fetch()]),
    []
  )

  const [policyToDelete, setPolicyToDelete] = React.useState<AttendancePolicy | null>(null)

  if (loading)
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  const onDeletePolicy = async (closePortal: ClosePortalFn) => {
    if (!policyToDelete) return

    closePortal()
    await policyToDelete.destroy()
  }

  return (
    <>
      <Section
        illustration="clock-app"
        title={i18n.t('time_tracking.settings.policies.title')}
        description={i18n.t('time_tracking.settings.policies.description')}
      >
        <List>
          {attendancePolicies.map((policy) => (
            <List.Item key={policy.id}>
              <PolicyCard policy={policy} showDeleteModal={() => setPolicyToDelete(policy)} />
            </List.Item>
          ))}
        </List>
      </Section>

      {policyToDelete && (
        <Modal
          illustration="delete-cross"
          title={i18n.t('app_store_v2.apps.time_tracking.delete_modal.title')}
          description={i18n.t('app_store_v2.apps.time_tracking.delete_modal.description')}
          onClose={() => setPolicyToDelete(null)}
          onSubmit={onDeletePolicy}
          footer={
            <Button type="negative" submit>
              {i18n.t('app_store_v2.apps.time_tracking.delete_modal.button')}
            </Button>
          }
        />
      )}
    </>
  )
}

export default observer(TimeTrackingPolicy)
